// Map
import {createMap, fitMap} from './map';

// Layers
// import {addHotspotsLayer} from './layers/hotspots';
import {addIncidentsDetailLayer} from './layers/incidents';
import {addPerimetersDetailLayer} from './layers/perimeters';
import {addEvacuationZonesDetailLayer} from './layers/evacuation-zones';

// Other
import {cdnUrl, mapboxAccessToken} from './resources/constants';
import {setLastUpdatedTimeSince, decodeTopojsonFeatures, parseParams} from './resources/utils';
import {zoomToQueryParamsDetail} from './methods/zoom'

// d3
import {select} from 'd3-selection';

mapboxgl.accessToken = mapboxAccessToken;

const bootMap = (topodata) => {

  window.fireData = {
    'perimeters': decodeTopojsonFeatures(topodata, 'perimeters'),
    'incidents': decodeTopojsonFeatures(topodata, 'incidents'),
    // 'hotspots': decodeTopojsonFeatures(topodata, 'hotspots'),
    'evacuationZones': decodeTopojsonFeatures(topodata, 'evacuation_zones'),
    'fireList': topodata.fire_list,
    'metadata': {
      'lastArchived': topodata.metadata.last_archived
    }
  };

  // Cut out the Bobcat fire in Montana for now as a hack
  window.fireData.incidents.features = window.fireData.incidents.features.filter(f => {
    return (f.properties.slug == 'bobcat' && f.properties.state == 'MT') ? false : true
  });
  window.fireData.fireList = window.fireData.fireList.filter(d => {
    return (d.slug == 'bobcat' && d.state == 'MT') ? false : true
  })
  window.fireData.perimeters.features = window.fireData.perimeters.features.filter(d => {
    return (d.properties.slug == 'bobcat') ? false : true
  });

  // Get query string parameters
  const paramDict = parseParams(window.location.search.replace('?', ''));

  // Parse query string parameters
  let opts = {};
  if (paramDict['fire']) {
    const fire = paramDict['fire'].toLowerCase();
    const foundPerimeterBbox = topodata.objects.perimeters.geometries.find(
        f => f.properties.slug == fire
    );
    const foundCoords = topodata.fire_list.find(f => f.slug == fire);
    if (foundPerimeterBbox) {
      opts['bounds'] = foundPerimeterBbox.properties.bbox;
      opts['fitBoundsOptions'] = {
        'padding': {top: 150, bottom: 30, left: 30, right: 30}
      }
    } else if (foundCoords) {
      opts['center'] = [foundCoords['x'], foundCoords['y']];
    }
  } else if (paramDict['point']) {
    const parsedPoints = paramDict['point'].split(',');
    opts['center'] = [parseFloat(parsedPoints[0]), parseFloat(parsedPoints[1])];
  }

  // Draw the map
  window.fireMap = createMap('mapbox://styles/latimes/ck26lenlp0acg1cs6vozpkqt4', 'detail', opts);

  // Set timestamps
  setLastUpdatedTimeSince(topodata.metadata.last_archived);

  // Load layers
  window.fireMap.on('load', function() {
    // Add layers
    // addHotspotsLayer('detail');
    if (paramDict['fire']){
      addIncidentsDetailLayer(paramDict['fire']);
    }
    // Refit the map
    fitMap();
    zoomToQueryParamsDetail(window.location.search.replace('?', ''));
    addPerimetersDetailLayer('detail');
    addEvacuationZonesDetailLayer('detail');
  });

  // Load other features
  window.fireMap.on('idle', function(){
    let fc = select('#fire-info .right .keys');
    let ct = 0;

    // Add hotspots
    // const hotspotsInView = window.fireMap.queryRenderedFeatures({ layers: ['pts-layer'] });
    // if(hotspotsInView.length > 0){
    //   if(!document.getElementById('hotspots-updated')){
    //     ct += 1;
    //     fc.append('div')
    //       .attr('id', 'hotspots-updated')
    //       .classed(`ct-${ct}`, true)
    //       .html('<span class="icon hotspot"></span> Estimated areas on fire according to satellite analysis')
    //   }
    // }

    // Add any evacuation layers
    const evacuationsInView = window.fireMap.queryRenderedFeatures({ layers: ['evacuation-zones'] });
    const mandatory = evacuationsInView.find(d => d.properties.mandatory === 'true');
    if (mandatory) {
      if(!document.getElementById('mandatory-perim')){
        ct += 1;
        fc.append('div')
          .attr('id', 'mandatory-perim')
          .classed(`ct-${ct}`, true)
          .html('Mandatory evacuation zone')
      }
    }
    const warning = evacuationsInView.find(d => d.properties.mandatory === 'false');
    if (warning) {
      if (!document.getElementById('warning-perim')) {
        ct += 1;
        fc.append('div')
          .attr('id', 'warning-perim')
          .classed(`ct-${ct}`, true)
          .html('Evacuation warning')
      }
    }
  })
};

fetch(cdnUrl)
  .then(r => r.json())
  .then(bootMap);
